document.addEventListener('DOMContentLoaded', function () {
    'use strict';

    function initializeCarFilterModalEvents() {
        window.addEventListener('saveCarFilterModal.success', event => {
            $('#savedFilterModal').modal('hide');
        });

        window.addEventListener('saveCarFilterModal.switchToRegistrationTab', event => {
            $('#regFilter-tab').click();
        });
    }

    initializeCarFilterModalEvents();
});
